import * as styles from 'styles/pages/Styleguide.css'
import Anchor from 'components/atoms/navigation/Anchor'
import SGInsights from 'components/utils/styleguide/SGInsights'
import SGHighlights from 'components/utils/styleguide/SGHighlights'
import { SGFeedPost } from 'components/utils/styleguide/SGFeedPost'
import { SGFeedPostCompose } from 'components/utils/styleguide/SGFeedPostCompose'

const SGOrganisms = () => (
  <Anchor placement='organisms'>

    <Anchor placement='feed_post_compose'>
      <h2 className={ styles.sgHeading }>Feed Post Compose</h2>
      <SGFeedPostCompose />
    </Anchor>

    <Anchor placement='feed_post'>
      <h2 className={ styles.sgHeading }>Feed Post</h2>
      <SGFeedPost />
    </Anchor>

    <Anchor placement='organisms_insights'>
      <h2 className={ styles.sgHeading }>Insights</h2>
      <SGInsights />
    </Anchor>

    <Anchor placement='organisms_highlights'>
      <h2 className={ styles.sgHeading }>Top Opportunities</h2>
      <SGHighlights />
    </Anchor>

  </Anchor>
)

export default SGOrganisms
